import React from 'react'

import QueryLoader from '~/components/QueryLoader'
import StreakCalendar from '~/components/streaks/StreakCalendar'
import SkeletonLoader from '~/components/ui/SkeletonLoader'
import useStreakData from '~/hooks/useStreakData'
import { useCommonTx } from '~/hooks/useTranslationForNamespace'

const StreakCard = (): JSX.Element => {
  const t = useCommonTx('common')
  const { currentStreakLength, bestStreakLength, loading, error } = useStreakData()

  return (
    <QueryLoader
      loading={loading}
      error={error}
      data={!loading}
      LoadingComponent={<SkeletonLoader className='w-full h-[240px]' />}
    >
      <div className='w-full shadow-drop-shadow-1 border border-border-subdued rounded-lg bg-surface-default'>
        <div className='p-4 pl-6 flex flex-row items-center justify-between border-b border-border-subdued'>
          <div className='text-micro-text-1 uppercase text-text-subdued'>{t('trainingStreaks')}</div>
        </div>
        <div className='p-4 pt-8 pb-10 flex flex-col items-center'>
          <StreakContent currentStreakLength={currentStreakLength} bestStreakLength={bestStreakLength} />
        </div>
      </div>
    </QueryLoader>
  )
}

export const StreakContent = ({
  currentStreakLength,
  bestStreakLength,
}: {
  currentStreakLength: number
  bestStreakLength: number
}) => {
  const t = useCommonTx('common')
  return (
    <>
      <StreakCalendar inkBackground={false} />
      <div className='mt-6 flex flex-row justify-between items-center gap-12'>
        <div className='flex flex-col items-center'>
          <div className='mb-1 text-heading-3'>{t('streaks.day', { count: currentStreakLength })}</div>
          <div className='text-caption-1 text-text-subdued'>{t('streaks.currentStreak')}</div>
        </div>
        <div className='flex flex-col items-center'>
          <div className='mb-1 text-heading-3'>{t('streaks.day', { count: bestStreakLength })}</div>
          <div className='text-caption-1 text-text-subdued'>{t('streaks.bestStreak')}</div>
        </div>
      </div>
    </>
  )
}

export default StreakCard
